import { getToken } from '../helpers/Token';
import axios, { AxiosRequestConfig } from 'axios';
import cartoondrawUrls from "../configs/cartoondraw/cartoondrawUrls";

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const cartoondrawApi = axios.create({ baseURL: cartoondrawUrls.baseURL });
cartoondrawApi.interceptors.request.use(onRequest);

export default cartoondrawApi;
